export default __webpack_public_path__ + "5a51e2a54b1adb29645f8b3f95341f68.svg";